function archivePaginationScroll() {
	$(window).on('load', function() {
		var $results = $( '.js-blog-items-wrap' );
		var	offset   = 120;

		if ( ! /\/page\/\d+/.test( window.location.pathname ) || ! $results.length ) {
			return;
		}

		$('html, body').animate({
            scrollTop: $results.offset().top - offset
        }, 500);
		
	} );
}

archivePaginationScroll();
